// Inpainting Page Entry Point
import './styles/inpainting.scss';
import { injectTransformControlsStyles } from './utils/image-transform-controls.js';
import { initInpaintingPage } from './inpainting-logic.js';

// Inject transform controls styles
injectTransformControlsStyles();

// Make initInpaintingPage available globally for HTML
(window as any).initInpaintingPage = initInpaintingPage;

console.log('✏️ MCP Inpainting loaded');
